/**
 * O ERRO DE SENHA QUE O SUPABASE DEVOLVE, EM PORTUGUÊS.
 *
 * 14/09/2026 — o projeto foi pro plano Pro e o dono decidiu ligar a proteção
 * contra senha vazada (o Supabase confere a senha na base HaveIBeenPwned e
 * recusa a que já apareceu em vazamento). Antes de ligar, conferi: as SEIS
 * telas/rotas onde uma pessoa escolhe senha devolviam `error.message` cru — ou
 * seja, a recusa chegaria em inglês ("Password is known to be weak…"), numa
 * tela que não explica o porquê.
 *
 * Um lugar só, usado pelos dois lados (tela e rota), pra mensagem não divergir.
 *
 * ⚠️ O que o SDK garante (auth-js, `WeakPasswordReasons`): código
 * `weak_password` e motivos 'length' | 'characters' | 'pwned'. O texto em inglês
 * pode mudar entre versões — por isso decide pelo CÓDIGO e pelos MOTIVOS, e o
 * texto só entra como reserva quando a rota admin não repassa os motivos.
 *
 * Erro que não é de senha passa INTACTO: esconder "e-mail já existe" atrás de
 * uma mensagem de senha seria pior que deixar em inglês.
 */

import { SENHA_DICA } from "./senha";

type ErroDoAuth = {
  code?: string | null;
  message?: string | null;
  reasons?: readonly string[] | null;
} | null | undefined;

export const MSG_SENHA_VAZADA =
  "Essa senha já apareceu em vazamento de dados na internet. Escolha outra.";
// 🟥 14/09: a 1ª versão desta frase exigia "maiúsculas, minúsculas, número e
// símbolo" — uma regra que NÃO EXISTE em lugar nenhum do sistema. A regra real é
// a de `senha.ts`, e a mensagem agora é montada a partir dela, não reescrita.
export const MSG_SENHA_FRACA = `Essa senha é fraca demais. ${SENHA_DICA}`;
export const MSG_SENHA_IGUAL = "A nova senha precisa ser diferente da senha atual.";

export function mensagemDeErroDeSenha(err: ErroDoAuth): string {
  if (!err) return "";
  const texto = err.message ?? "";
  if (err.code === "same_password") return MSG_SENHA_IGUAL;
  if (err.code === "weak_password") {
    const motivos = err.reasons ?? [];
    // Sem motivos (rota admin pode não repassar), o texto é a única pista.
    if (motivos.includes("pwned") || /pwned|leaked|breach|known to be weak/i.test(texto)) return MSG_SENHA_VAZADA;
    return MSG_SENHA_FRACA;
  }
  return texto;
}
